<div class="px-10 flex flex-col gap-y-8 text-2xl font-bold text-white">
  <a
    routerLink="/dashboard"
    routerLinkActive="bg-white/10 text-blue-200 scale-105 shadow"
    class="transition-all duration-200 rounded-lg px-4 py-3 hover:bg-white/10 hover:text-blue-200 hover:scale-105"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    Dashboard
  </a>
  <a
    routerLink="/employee"
    routerLinkActive="bg-white/10 text-blue-200 scale-105 shadow"
    class="transition-all duration-200 rounded-lg px-4 py-3 hover:bg-white/10 hover:text-blue-200 hover:scale-105"
  >
    Employees
  </a>
  <a
    routerLink="/department"
    routerLinkActive="bg-white/10 text-blue-200 scale-105 shadow"
    class="transition-all duration-200 rounded-lg px-4 py-3 hover:bg-white/10 hover:text-blue-200 hover:scale-105"
  >
    Departments
  </a>
</div>
